import SecuredByContent from '@pages/final-views/secured-by-content';
import React from 'react';

const FeedbackShellFooter = () => (
  <div className="bg-gray-50 border-t border-gray-100">
    <SecuredByContent />
  </div>
);

export default FeedbackShellFooter;
